<app-documents-header #documentsHeader="documentsHeader" [widgetsettings]="widgetsettings" [documents]="documents"
  [widgetSigned]="firmaImagen || metadataCert?.length" (selectedDoc)="getSelectedDoc($event)"></app-documents-header>
<div class="viewer">
  <section id="viewer" class="viewer__document">
    <ng-container *ngIf="isLoadedDoc">
      <h3 class="viewer__document--title">{{nameDoc}}</h3>
      <ng-container *ngIf="extension === 'PDF'">
      <div *ngFor="let _ of [].constructor(totalPages), let i = index">
        <div id="divBoard_{{i + 1}}" class="viewer__document--container"
          [ngStyle]="{'height': !isPageLoaded(i) ? '796px' : 'auto'}">
          <!-------------- loader for each page ----------->
          <div *ngIf="!isPageLoaded(i)" class="loading__doc">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
          <!-------------- loader for each page ----------->

          <!---------- widgets ----------->
          <div *ngFor="let w of widgetsettings, let x = index">
            <ng-container>
              <div *ngIf="isRenderingWidget(w, i)" id={{w.idWidget}} class="viewer__document--containerWidget"
                (click)="openSignComponent(w.idWidget)" [ngStyle]="w.positions">
                <div *ngIf="(!w.imagePath || w.onlyText) && !w.textSignCert" class="viewer__document--gesture">
                  <div *ngIf="!w.onlyText" class="viewer__document--gesture__content">
                    <div>
                      <img
                        [src]="isCert ? 'https://d2i8kkeqh9ciqw.cloudfront.net/8b76e0d/assets/img/digital-certificate-widget/icon.svg' : 'https://d2i8kkeqh9ciqw.cloudfront.net/6e16888/assets/img/signature-widget/trackpad-bkg-desktop.svg'"
                        alt="exampleGesture" />
                    </div>
                    <div class="text">
                      <p>{{ (isCert ? ('signaturit_pro.document.click_sign_cert_' + operationType) :
                        'signaturit_pro.document.click_sign') |
                        translate}}</p>
                    </div>
                  </div>
                  <div *ngIf="w.onlyText" class="viewer__document--gesture__content">
                    <p class="onlyText">
                      {{'pdf_documento_firmado' | translate:_transParam }} <span>{{date |
                        date:'dd-MM-yyyy, h:mm:ss'}}</span>
                      {{'pdf_utc_usuario' | translate:_transParam }}
                      <span>{{_finishProService.operationDetailResponse?.nifUser}}</span>
                    </p>
                  </div>
                  <div *ngIf="!isCert" class="viewer__document--gesture__tooltip">
                    <p>{{ 'signaturit_pro.document.fill_in_4' | translate:_transParam }} {{x + 1}} {{
                      'signaturit_pro.document.fill_in_5'
                      | translate:_transParam }} {{widgetsettings.length}}</p>
                  </div>
                </div>
                <div *ngIf="w.imagePath && !w.onlyText" class="viewer__document--gestureSign">
                  <div class="viewer__document--gestureSign__contentSign">
                    <img [src]="w.imagePath" alt="gesture" />
                    <mat-icon>check_circle</mat-icon>
                  </div>
                </div>
                <div *ngIf="w.textSignCert" class="viewer__document--gestureSign">
                  <img
                    src="https://d2i8kkeqh9ciqw.cloudfront.net/8b76e0d/assets/img/digital-certificate-widget/dcf-seal-bkg.svg"
                    alt="exampleGestureCert" />
                  <div class="viewer__document--gestureSign__contentSignCert">
                    <p class="viewer__document--gestureSign__text-item-title">{{ 'signaturit_pro.document.sign_cert1'
                      |
                      translate:_transParam }}</p>
                    <p class="viewer__document--gestureSign__text-item-value">[{{ 'signaturit_pro.document.sign_cert2'
                      |
                      translate:_transParam }}],</p>
                    <p class="viewer__document--gestureSign__text-item-title">{{ 'signaturit_pro.document.sign_cert3'
                      |
                      translate:_transParam }}</p>
                    <p class="viewer__document--gestureSign__text-item-value">[{{ 'signaturit_pro.document.sign_cert4'
                      |
                      translate:_transParam }}]</p>
                    <p class="viewer__document--gestureSign__text-item-title">{{ 'signaturit_pro.document.sign_cert5'
                      |
                      translate:_transParam }}</p>
                    <p class="viewer__document--gestureSign__text-item-value">[dd/mm/aaaa 00:00:00 UTC]</p>
                  </div>
                </div>
              </div>
            </ng-container>
            <div *ngIf="w.pages.includes(i+1) && w.type.includes('TEXT')" id={{w.idWidget}}
              class="viewer__document--containerWidget">
              <div class="viewer__document--gesture">
                <div class="viewer__document--gesture__content">
                  <input [(ngModel)]="w.textWidget" class="widgetText" type="text" [readonly]="!w.isEditable">
                </div>
              </div>
            </div>
            <div *ngIf="w.pages.includes(i+1) && w.type.includes('INITIALS')" id={{w.idWidget}}
              class="viewer__document--containerWidget">
              <div class="viewer__document--gesture">
                <div class="viewer__document--gesture__content">
                  <input class="widgetInitial" type="text" readonly [value]="w.initials">
                </div>
              </div>
            </div>
            <div (click)="picker.open()" *ngIf="w.pages.includes(i+1) && w.type.includes('DATE')" id={{w.idWidget}}
              class="viewer__document--containerWidget">
              <div class="viewer__document--gesture">
                <div class="viewer__document--gesture__content">
                  <input [(ngModel)]="w.date" class="widgetText" [matDatepicker]="dp"
                    placeholder="{{date | date: 'dd/MM/yyyy'}}" [disabled]="!w.isEditable">
                  <mat-datepicker-toggle matSuffix [for]="dp" class="calendar">
                    <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #dp [disabled]="!w.isEditable"></mat-datepicker>
                </div>
              </div>
            </div>
          </div>
          <!---------- widgets ----------->

          <!---------- PDF page ----------->
          <div class="page-renderer">
            <div id="page-renderer-wrapper-{{ i + 1 }}" class="page-renderer__wrapper">
              <!---------- Annotations ----------->
              <ng-container *ngFor="let input of inputList; let j = index;">
                <input
                  *ngIf="(input.page == page && input.type === 'checkbox' && isSinglePage) || (input.page == i + 1 && input.type === 'checkbox' && !isSinglePage)"
                  [id]="input.id" [readonly]="input.readonly" [type]="input.type" [name]="input.name"
                  (change)="changeValue($event, j, input.type)" [ngStyle]="getInputPosition(input)"
                  [value]="input.value" [checked]="input.checked">
                  <input
                    *ngIf="(input.page == page && input.type === 'radio' && isSinglePage) || (input.page == i + 1 && input.type === 'radio' && !isSinglePage)"
                    [id]="input.id" [readonly]="input.readonly" [type]="input.type" [name]="input.name"
                    (change)="changeValue($event, j, input.type)" [ngStyle]="getInputPosition(input)"
                    [value]="input.value" [checked]="input.value">
                <input
                  *ngIf="(input.page == page && input.type === 'text' && isSinglePage) || (input.page == i + 1 && input.type === 'text' && !isSinglePage)"
                  [id]="input.id" [readonly]="input.readonly" [type]="text" [name]="input.name"
                  [ngStyle]="getInputPosition(input)" [(ngModel)]="input.value" (input)="setInputListDocument(j)"
                  [value]="input.value">
              </ng-container>
              <!---------- Annotations ----------->
              <img id="page-renderer-image-{{ i + 1 }}" alt="document-page-{{ i + 1 }}" class="page-renderer__img"
                [attr.page]="i + 1" />
            </div>
          </div>
          <!----------- PDF page ----------->

        </div>
      </div>
      </ng-container>

      <div class="containerXML" *ngIf="extension === 'XML'">
        <pre lang="xml">
              <code highlight="{{xml | xmlbeauty}}"></code>
            </pre>
      </div>
    </ng-container>

    <div class="viewer__document--controls" *ngIf="isSinglePage">
      <signaturit-button class="viewer__document--controls-prev" text="{{ 'finish_btn_anterior' |
        translate:_transParam }}" type="secondary" size="sm" (click)="changePage()" [disabled]="prevPageBtn"
        icon="keyboard_arrow_left"></signaturit-button>
      <mat-form-field class="viewer__document--controls-field">
        <input class="text-center" type="text" matInput [(ngModel)]="page" ngDefaultControl>
      </mat-form-field> /
      <mat-form-field class="viewer__document--controls-field">
        <input class="text-center" type="number" matInput [(ngModel)]="trueTotalPages" readonly ngDefaultControl>
      </mat-form-field>
      <signaturit-button class="viewer__document--controls-next" text="{{
        'finish_btn_siguiente' | translate:_transParam }}" type="secondary" size="sm" (click)="changePage(true)"
        [disabled]="nextPageBtn" altIcon="keyboard_arrow_right"></signaturit-button>
    </div>

    <div class="viewer__document--space"></div>

    <div *ngIf="showFooter" id="viewerFooter" class="viewer__footer">
      <div *ngIf="operationType !== 'DWN'" class="viewer__footer--content">
        <div>
          <mat-checkbox [checked]="termsAccepted" (change)="changeTerms($event.checked)" [disableRipple]="true"
            class="checkbox">
            {{ 'signaturit_pro.scrivener_loi.label_read_privacy_policy' | translate:_transParam }}
          </mat-checkbox>
          <span class="labelOpenTyC" (click)="openTerms()">{{
            'signaturit_pro.scrivener_loi.privacy_policy' |
            translate:_transParam }}</span>
        </div>
        <div>
          <mat-checkbox *ngIf="hasReadAllDoc" [(ngModel)]="readAllDoc" class="viewer__footer--policyTextReadAllDoc">{{
            'read_all_doc' | translate:_transParam }}</mat-checkbox>
          </div>
        <div id="buttons-actions" class="viewer__footer--contentActions">
          <signaturit-button *ngIf="operationType === 'VAL' && templateCode === 'DRAG_VAL'"
            text="{{ 'signaturit_pro.document.review_btn' | translate:_transParam }}" type="tertiary" size="md"
            [showLoaderWithText]="showLoaderRejectBegin" (click)="reject()"></signaturit-button>
          <signaturit-button *ngIf="operationType === 'VAL'"
            text="{{ 'signaturit_pro.document.validate_btn' | translate:_transParam }}" type="primary" size="md"
            (click)="startSignProccess()" [disabled]="checkButtonDisabled()"
            [showLoaderWithText]="isOperationFinished"></signaturit-button>
          <signaturit-button *ngIf="operationType !== 'DWN' && operationType !== 'VAL'"
            text="{{ 'signaturit_pro.document.accept_btn' | translate:_transParam }}" type="primary" size="md"
            (click)="startSignProccess()" [disabled]="checkButtonDisabled()"
            [showLoaderWithText]="isOperationFinished"></signaturit-button>
        </div>
      </div>
      <div *ngIf="operationType === 'DWN'" class="viewer__footer--content">
        <div id="buttons-actions" class="viewer__footer--contentActions">
          <signaturit-button text="{{'finish_btn_descargartodos' | translate:_transParam }}" type="primary" size="md"
            (click)="downloadDocuments()" [showLoaderWithText]="isOperationFinished"
            [disabled]="isOperationFinished"></signaturit-button>
        </div>
      </div>
    </div>
  </section>
</div>

<div *ngIf="signaturePadControl">
  <signature-pad (signature)="showSignature($event)" (close)="closeSignComponent($event)" [docFields]="inputList" [metadataViewer]="metaDataOperation"
    (documentSigned)="getDocSigned($event)" [doc]="documentB64" [widgetSigBio]="widgetsettings"></signature-pad>
</div>
<div *ngIf="signatureCertControl">
  <signature-cert [idDocument]="idDocument" (finish)="getMetadataCert($event)"
    (close)="closeSignComponent()"></signature-cert>
</div>
<signaturit-notification id="sig-notification" [timer]="13" [customText]="notifMessage"></signaturit-notification>
